<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(252,252,253,0.6)"
  size="default"
  color="#00b2ff"
  type="ball-clip-rotate"
></ngx-spinner>
<p-toast class="custom-toast" position="bottom-center" key="bc"></p-toast>

<!--<p-scrollTop id="scrollTop" styleClass="animate__animated animate__backInDown"></p-scrollTop>-->
